import { render, staticRenderFns } from "./RevshareViewTiers.vue?vue&type=template&id=4fae24fb&scoped=true&"
import script from "./RevshareViewTiers.vue?vue&type=script&lang=ts&"
export * from "./RevshareViewTiers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fae24fb",
  null
  
)

export default component.exports